import { useParams } from 'react-router-dom';
import DateTimeColumn from 'components/DateTimeColumn';
import { Reminder } from 'data/firestore/agent/reminder/types';
import useCustomer from 'data/firestore/agent/customer/useOnce';
import StatusColumn from '../columns/status';
import {
    ReminderDetailsContainer,
    ReminderSection,
    ReminderSectionTitle,
    ReminderInfo,
    DetailLabel,
    DetailValue,
} from './styled';
import CustomerInfo from './CustomerInfo';
import OpportunityInfo from './OpportunityInfo';

const ReminderDetails = ({ reminder }: { reminder?: Reminder }) => {
    const { agentId = '' } = useParams();
    const { data: customer, isLoading } = useCustomer(
        agentId as string,
        reminder?.customerId as string,
        { disabled: !agentId || !reminder?.customerId },
    );

    return (
        <ReminderDetailsContainer>
            <ReminderSection>
                <ReminderSectionTitle>General Information</ReminderSectionTitle>
                <ReminderInfo>
                    <DetailLabel>Purpose</DetailLabel>
                    <DetailValue>{reminder?.purpose}</DetailValue>
                </ReminderInfo>

                <ReminderInfo>
                    <DetailLabel>Context</DetailLabel>
                    <DetailValue>{reminder?.context}</DetailValue>
                </ReminderInfo>

                <ReminderInfo>
                    <DetailLabel>Status</DetailLabel>
                    <DetailValue>
                        <StatusColumn
                            value={reminder?.status}
                        />
                    </DetailValue>
                </ReminderInfo>

                <ReminderInfo>
                    <DetailLabel>Reminder ID</DetailLabel>
                    <DetailValue>{reminder?.id}</DetailValue>
                </ReminderInfo>

                <ReminderInfo>
                    <DetailLabel>Scheduled At</DetailLabel>
                    <DetailValue>
                        {reminder?.timestamp && (
                            <DateTimeColumn
                                value={new Date(reminder?.timestamp)}
                                showRelativeDate
                                showDateInTimeZone={{
                                    label: 'Customer Time',
                                    value: customer?.address?.timezone,
                                }}
                            />
                        )}
                    </DetailValue>
                </ReminderInfo>
            </ReminderSection>

            <ReminderSection>
                <ReminderSectionTitle>Related Items</ReminderSectionTitle>
                {reminder?.taskId && (
                    <ReminderInfo>
                        <DetailLabel>Task ID</DetailLabel>
                        <DetailValue>{reminder?.taskId}</DetailValue>
                    </ReminderInfo>
                )}

                {reminder?.customerId && (
                    <ReminderInfo>
                        <DetailLabel>Customer</DetailLabel>
                        <CustomerInfo customer={customer} isLoading={isLoading} />
                    </ReminderInfo>
                )}

                {reminder?.opportunityId && (
                    <ReminderInfo>
                        <DetailLabel>Opportunity</DetailLabel>
                        <OpportunityInfo opportunityId={reminder.opportunityId} />
                    </ReminderInfo>
                )}
            </ReminderSection>
        </ReminderDetailsContainer>
    );
};

export default ReminderDetails;
